module.exports = __webpack_public_path__ + "img/notice-rt.3bf9cd73.png";